import * as v from 'valibot'

export const getIsOptimusEnabledSchema = () => {
	return v.object({
		enabled: v.boolean(),
	})
}

const timing_plan_monitor_metrics = v.object({
	fl_volume_count_per_day: v.nullable(v.number()),
	fl_control_delay_seconds_per_day: v.nullable(v.number()),
	tomtom_mainline_delay_mean_seconds: v.nullable(v.number()),
	tomtom_sidestreet_delay_mean_seconds: v.nullable(v.number()),
	fl_split_failure_ratio: v.nullable(v.number()),
	fl_split_failure_from_stops_ratio: v.nullable(v.number()),
	approach_queue_length_95th_feet_mean: v.nullable(v.number()),
	approach_num_stops_mean: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_all_phases_ratio_atspm: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_all_phases_ratio_atspm_probe: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_all_phases_ratio_probe: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_mainline_ratio_atspm: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_mainline_ratio_atspm_probe: v.nullable(v.number()),
	fl_arrivals_on_green_yellow_mainline_ratio_probe: v.nullable(v.number()),
	fl_platoon_all_phases_ratio: v.nullable(v.number()),
	fl_platoon_mainline_ratio: v.nullable(v.number()),
	fl_control_delay_per_vehicle_mean_seconds: v.nullable(v.number()),
	intersection_approach_speeding_lvl1_ratio: v.nullable(v.number()),
	intersection_approach_speeding_lvl2_ratio: v.nullable(v.number()),
	fl_co2_emissions_equivalent_grams_per_day: v.nullable(v.number()),
	fl_fuel_consumption_litres_per_day: v.nullable(v.number()),
	fl_annualized_cost_of_delay_dollars: v.nullable(v.number()),
})

export const getTimingPlanMonitorSchema = () => {
	return v.object({
		before: v.nullable(timing_plan_monitor_metrics),
		after: v.nullable(timing_plan_monitor_metrics),
	})
}
